import { render, staticRenderFns } from "./home-page.vue?vue&type=template&id=40468ace&scoped=true&"
import script from "./home-page.vue?vue&type=script&lang=js&"
export * from "./home-page.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/pages/home/user-profile-modal.scss?vue&type=style&index=0&id=40468ace&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40468ace",
  null
  
)

export default component.exports